import parseCents from './parseCents.js'
export default parseCents
